// extracted by mini-css-extract-plugin
export default {"create":"styles_create__b2Rye","row":"styles_row__NvpA7","col":"styles_col__Wg5xu","flexRight":"styles_flexRight__N3V-l"};